export const harmId = "{D4A3AEC2-D56A-965F-C817-F34F8DF4ADD0}";
export const depleteId = "{57038D9A-AEC9-0AA6-C114-1B805BC374B8}";